import React, { useState, useEffect, FC } from "react";
import { Modal, Row, Col, Form, Table, Select, Space, InputNumber } from "antd";
import { useGlobalState } from "../../context/Provider";
import { selectedSkuCoulmns } from "../../helpers/sku.helper";
import {
  EditableRow,
  EditableCell,
} from "../../components/selectSkuEditing/selectSkuEditing.component";
import { handleSelectToWarehouse } from "../../constants/product.constant";
import { ManyToWarehouse } from "../../api/sku";
import "./selectedSkuModal.style.scss";

interface SelectedSkuModalProps {
  visible: boolean;
  setVisible: (value: boolean) => void;
  info: any;
  handleOk: any;
}

const SelectedSkuModal: FC<SelectedSkuModalProps> = (props) => {
  const { visible, setVisible, info, handleOk }: any = props;
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);
  const [count, setCount] = useState<number>(1);
  const { langState, warehouserList }: any = useGlobalState();
  const [warehouseId, setWarehouseId] = useState(0);
  const [type, setType] = useState(0);
  const [form] = Form.useForm();

  const { Option } = Select;

  useEffect(() => {
    const test = info.map((item: any) => {
      return {
        ...item,
        count,
      };
    });

    setData(test);
  }, [count, info]);

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const onCreate = (values: any) => {
    const test = data.map((item: any) => ({
      skuId: item.id,
      quantity: item.count,
      warehouseId: warehouseId,
    }));
    setConfirmLoading(true);
    ManyToWarehouse(type, test).then((res: any) => {
      setConfirmLoading(false);
      if (res.status === 200) {
        setVisible(false);
        handleOk();
      }
    });
  };
  const handleCancel = () => {
    setVisible(false);
  };
  const handleSave = (row: any) => {
    console.log("handleSave");
    const newData = [...data];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setData(newData);
  };
  const CT = selectedSkuCoulmns(langState.locale).map((col: any) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record: any) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSave,
      }),
    };
  });
  return (
    <Modal
      title={
        langState.locale === "en-US" ? "selected product" : "sku های منتخب"
      }
      visible={visible}
      width={1250}
      style={{ top: 10 }}
      onCancel={handleCancel}
      confirmLoading={confirmLoading}
      onOk={(value: any) => {
        form.validateFields().then((values) => {
          onCreate(values);
        });
      }}
    >
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Form
            form={form}
            layout="vertical"
            name="form_in_modal"
            initialValues={{ modifier: "public" }}
          >
            <Space size={24}>
              <Form.Item
                label={langState.locale === "en-US" ? "type" : " نوع"}
                name="type"
                rules={[
                  {
                    required: true,
                    message: "Please select your warehous!",
                  },
                ]}
              >
                <Select
                  placeholder={
                    langState.locale === "en-US"
                      ? "select to type"
                      : "انتخاب نوع"
                  }
                  style={{ width: 200 }}
                  onChange={setType}
                >
                  {handleSelectToWarehouse.map((item: any) => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label={
                  langState.locale === "en-US"
                    ? "Destination warehouse"
                    : "انبار مقصد"
                }
                name="warehousName"
                rules={[
                  {
                    required: true,
                    message: "Please select your warehous!",
                  },
                ]}
              >
                <Select
                  style={{ width: 200 }}
                  placeholder="select to warehouse"
                  onChange={setWarehouseId}
                >
                  {warehouserList.data.map((item: any) => (
                    <Option value={item.id} key={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label={langState.locale === "en-US" ? "Count" : "تعداد"}
                name="quantity"
                rules={[
                  {
                    required: false,
                    message:
                      langState.locale === "en-US"
                        ? "Please select your typs!"
                        : "لطفا نوع رو انتخاب کنید ",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  max={100000}
                  style={{ width: "150px" }}
                  defaultValue={count}
                  onChange={setCount}
                />
              </Form.Item>
            </Space>
          </Form>
        </Col>
        <Col span={24}>
          <Table
            components={components}
            rowClassName={() => "editable-row"}
            className="tableselectedSku"
            columns={CT}
            dataSource={data}
            size="middle"
            pagination={false}
            scroll={{ y: "calc(100vh - 355px)" }}
            loading={false}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default SelectedSkuModal;
